import React from 'react';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

import anonymousImage from '../../assets/anonymousBlackSmall.svg';

import AnonymousFileEdit from '../common/file-edit/anonymous-file-edit.component';
// import AnonymousTypeSelector from '../new-question/anonymous-type-selector.component';
// import AnonymouseDatePicker from '../new-question/anonymouse-date-picker.component';
import AnonymousInlineEdit from '../common/inline-edit/anonymous-inline-edit.component';

import { useAnonymousEditQuestionStyles } from './anonymous-edit-question-display.styles';
import { useAnonymousEditQuestionStylesR } from './anonymous-edit-question-display-r.styles';


const AnonymousEditQuestionDisplay = ({ attId, file, onDelete, onFile, editValue, onChangeText,
    type, onType, selectedDate, onDateChange, onAnonymous, disabled, onConfirm, onClose, strings, locale }) => {

    // console.log('Edit Question props', attId, file, editValue);

    const classesL = useAnonymousEditQuestionStyles();
    const classesR = useAnonymousEditQuestionStylesR();
    const classes = locale === 'he'? classesR : classesL;

    const popUpdir = locale === 'he'? 'rtl' : 'ltr';

    const caractersLength = !editValue? 0 : editValue.length;

    return (
        <div dir={popUpdir} className={classes.editQuestion}>

            <Typography dir='auto' className={classes.title}>{strings.title}</Typography>

            <Divider className={classes.divider} />

            <div className={classes.inputsHolder}>

                <AnonymousFileEdit
                    accept='image/*'
                    attId={attId}
                    file={file}
                    onDelete={onDelete}
                    onFile={onFile}
                    strings={strings}
                />

                {/* <AnonymousTypeSelector type={type} onType={onType} strings={strings} locale={locale} />

                <AnonymouseDatePicker type={type} selectedDate={selectedDate} onDateChange={onDateChange} strings={strings} locale={locale} /> */}

                <div className={classes.inputHolder}>

                    <AnonymousInlineEdit
                        autoFocus={true}
                        multiline={true}
                        value={editValue}
                        onChangeText={onChangeText}
                        strings={strings}
                        locale={locale}
                    />

                </div>

                <div className={classes.caractersHolder}>

                    <div className={classes.anonymous}>

                        <Button className={classes.anonymousButton} component='span' onClick={onAnonymous}>
                            <img src={anonymousImage} alt='abutton' />
                        </Button>

                        <Typography className={classes.caracters}>{strings.writeAnonymously}</Typography>

                    </div>

                    <Typography className={classes.caracters}>{`${caractersLength}/1024`}</Typography>

                </div>

                <div className={classes.buttons}>

                    <div className={classes.anonymous}>

                        <div>
                            <Button className={classes.cancelButton} onClick={onClose}>
                                {strings.cancelButton}
                            </Button>
                        </div>

                        <div>
                            <Button disabled={disabled} className={classes.saveButton} onClick={onConfirm}>
                                {strings.saveButton}
                            </Button>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default AnonymousEditQuestionDisplay;
